// extracted by mini-css-extract-plugin
export default {"managementSetting":"index_managementSetting__nkuON","managementSettingModal":"index_managementSettingModal__vpVBe"};